import React from 'react';
import { colors } from '../../styles/shared';

/**
 * Gemensamt sidhuvud: rubrik med ikon, kort förklaring under, och knappar till höger.
 * Används överst på varje sida så att alla ser likadana ut.
 */
interface Props {
    icon?: string;
    title: React.ReactNode;
    description?: React.ReactNode;
    /** Knappar eller statusrad till höger om rubriken. */
    actions?: React.ReactNode;
    /** Klass för utskrift, t.ex. "no-print". */
    className?: string;
    style?: React.CSSProperties;
}

const PageHeader: React.FC<Props> = ({ icon, title, description, actions, className, style }) => (
    <div className={className} style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
        gap: 12, flexWrap: 'wrap', marginBottom: 20, ...style,
    }}>
        <div style={{ minWidth: 0 }}>
            <h1 style={{ margin: 0, fontSize: 'clamp(18px, 4vw, 24px)', fontWeight: 700, color: colors.textDark, lineHeight: 1.25 }}>
                {icon && <span style={{ marginRight: 8 }}>{icon}</span>}{title}
            </h1>
            {description && (
                <p style={{ margin: '4px 0 0', color: colors.textMuted, fontSize: 14, maxWidth: 720 }}>{description}</p>
            )}
        </div>
        {actions && (
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>{actions}</div>
        )}
    </div>
);

export default PageHeader;
